import React from "react";
import emojiData from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

function MessageInput({ content, setContent, onSubmit, disabled, showEmojiPicker, setShowEmojiPicker, handleEmojiSelect, handleTyping }) {
    return (
        <form onSubmit={onSubmit} className="p-2 sm:p-4 border-t border-gray-700 bg-gray-900 flex gap-1 sm:gap-2 sticky bottom-0">
            <input
                className="flex-1 px-2 sm:px-4 py-1 sm:py-2 rounded-md bg-gray-800 border border-gray-600 text-white text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-white"
                placeholder="Type a message..."
                value={content}
                onChange={(e) => {
                    setContent(e.target.value);
                    handleTyping && handleTyping();
                }}
                disabled={disabled}
            />
            <button
                type="button"
                onClick={() => setShowEmojiPicker((prev) => !prev)}
                className="text-lg sm:text-xl px-1 sm:px-2"
                disabled={disabled}
            >
                😊
            </button>
            <button type="submit" className="bg-white text-black px-2 sm:px-4 py-1 sm:py-2 rounded-md text-xs sm:text-sm hover:bg-gray-200 transition">
                Send
            </button>

            {showEmojiPicker && (
                <div className="absolute bottom-[80px] right-3 -translate-x-3 z-50">
                    <div className="w-[250px] sm:w-[350px]">
                        <Picker
                            data={emojiData}
                            onEmojiSelect={handleEmojiSelect}
                            theme="dark"
                            perLine={7}
                            emojiSize={18}
                            previewPosition="none"
                            navPosition="bottom"
                        />
                    </div>
                </div>
            )}
        </form>
    );
}

export default MessageInput;


